export function borderCSSValue(border) {
    return `${border.thickness}px ${border.style} ${border.color}`;
}
export function boxShadowsCSSValue(shadow) {
    return shadow
        .map(s => `${s.offsetX}px ${s.offsetY}px ${s.blur}px ${s.spread}px ${s.color}`)
        .join(',');
}
export function dropShadowsFilterCSSValue() {
    return '';
    // return shadow.map(s => {
    //     return `drop-shadow(${s.offsetX}px ${s.offsetY}px ${s.blur}px ${s.color})`;
    // }).join(' ');
}
export function textShadowsCSSValue(shadow) {
    return shadow.map(s => `${s.offsetX}px ${s.offsetY}px ${s.blur}px ${s.color}`).join(',');
}
